import React from 'react';
import { Link } from 'react-router-dom';

const Crumbs = ({ href, light, label, mobileMaxWidth }) => {
    if (!href || label === 'devices') {
        return (
            <span
                className={`text-sm font-normal capitalize overflow-hidden text-ellipsis whitespace-nowrap ${light ? 'text-white opacity-80' : 'text-foreground opacity-50'}`}
                style={{ maxWidth: mobileMaxWidth }}
            >
                {label}
            </span>
        );
    }

    return (
        <Link
            to={href}
            className={`cursor-pointer text-sm font-normal capitalize overflow-hidden text-ellipsis whitespace-nowrap ${light ? 'text-white opacity-80' : 'text-foreground opacity-50'}`}
            style={{ maxWidth: mobileMaxWidth }}
        >
            {label}
        </Link>
    );
};

export default Crumbs;
